import styled from 'styled-components'

import {StaticBasicStyles} from '@/src/shared/assets/styles/static'

export const Article = styled.div`
  ${StaticBasicStyles}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`

export const H1 = styled.h1`
  font-weight: 450;
  line-height: 120%;
  //color: #000;
  margin-bottom: 15px;
  text-decoration: none;
`

export const Image = styled.div`
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    max-width: 1200px;
    height: auto !important;
  }
`
